export function setOrganizationOrders(state, organizationOrders) {
  state.organizationOrders = organizationOrders;
}

export function setEventOrders(state, eventOrders) {
  state.eventOrders = eventOrders;
}

export function setMemberPendingOrders(state, orders) {
  state.memberPendingOrders = orders;
}

export function setEventWebHookToken(state, orderWebhookToken = '') {
  if (!orderWebhookToken) return null;
  state.orderWebhookToken = orderWebhookToken;
  localStorage.setItem('WH_EVENT_TOKEN', orderWebhookToken);
}

export function deleteEventWebHookToken(state) {
  state.orderWebhookToken = '';
  localStorage.removeItem('WH_EVENT_TOKEN');
}
